import { create } from "zustand";

interface ProjectState {
  projectId: string;
  projectName: string;
  dirty: boolean;
  saving: boolean;
  hydrated: boolean;
  lastSavedAt: string | null;
  setProject: (id: string, name: string) => void;
  setProjectName: (name: string) => void;
  markDirty: () => void;
  markSaved: () => void;
  setHydrated: (hydrated: boolean) => void;
}

export const useProjectStore = create<ProjectState>((set) => ({
  projectId: "local-project",
  projectName: "Untitled Farm Scene",
  dirty: false,
  saving: false,
  hydrated: false,
  lastSavedAt: null,
  setProject: (projectId, projectName) => set({ projectId, projectName, dirty: false }),
  setProjectName: (projectName) => set({ projectName, dirty: true }),
  markDirty: () => set({ dirty: true }),
  markSaved: () => set({ dirty: false, saving: false, lastSavedAt: new Date().toISOString() }),
  setHydrated: (hydrated) => set({ hydrated }),
}));
